import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import { TableThWithSortIcon } from "@sso/components/TableThWithSortIcon";
import { useAppDispatch } from "@sso/hooks/useRedux";
import { setProductSortColumn } from "@sso/store/slices/product";
import { setSoftwareLicenceSoftwareId } from "@sso/store/slices/softwareLicence";
import { SoftwareSummary, SoftwareSummaryKeys, TableColumn } from "@sso/types";
import { LayoutTable, TD, TH, TableWrapper } from "@sso/ui/Table";

interface ProductLicenceTableProps {
  data: SoftwareSummary[];
  productLicenceTableColumns: TableColumn<string>[];
  dataKeys: SoftwareSummaryKeys[];
}

const UnderlinedTag = styled.span`
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const ProductLicenceTable = ({ data, productLicenceTableColumns, dataKeys }: ProductLicenceTableProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSortAction = (column: string) => {
    dispatch(setProductSortColumn(column));
  };

  const goToSoftwareLicencesTable = (product: SoftwareSummary) => {
    dispatch(setSoftwareLicenceSoftwareId(product.softwareId));
    navigate(`/management/licence-types/${product.name}`);
  };

  return (
    <TableWrapper>
      <LayoutTable>
        <thead>
          <tr>
            {productLicenceTableColumns.map(col => (
              <TH key={col.field} sortable={col.sortable} onClick={() => col.sortable && handleSortAction(col.field)}>
                {col.sortable ? <TableThWithSortIcon column={col.field} title={col.name} /> : col.name}
              </TH>
            ))}
            <TH textAlign="center">Actions</TH>
          </tr>
        </thead>
        <tbody>
          {data.map(product => (
            <tr key={product.softwareId}>
              {dataKeys.map(key => (
                <TD key={key}>{product[key]}</TD>
              ))}
              <TD>
                <UnderlinedTag onClick={() => goToSoftwareLicencesTable(product)}>Edit Licence Types </UnderlinedTag>
              </TD>
            </tr>
          ))}
        </tbody>
      </LayoutTable>
    </TableWrapper>
  );
};

export default ProductLicenceTable;
